function generatePriceFilter(fieldId) {
  return {
    filter: 'agNumberColumnFilter',
    floatingFilterComponent: 'AgGridPriceFilter',
    filterParams: {
      fieldId
    },
    floatingFilterComponentParams: {
      debounceMs: 800
    }
  }
}

function generateDateFilter() {
  return {
    floatingFilterComponent: 'AgGridTextDateFilter',
    floatingFilterComponentParams: {
      suppressFilterButton: true,
      debounceMs: 1500
    },
    filterParams: {
      newRowsAction: 'keep'
    }
  }
}

export const mapFilters = {
  list_price: generatePriceFilter('ag-list-price'),
  first_offer_price: generatePriceFilter('ag-first-offer-price'),
  forecasted_price: generatePriceFilter('ag-forecasted-price'),
  forecasted_local_price: generatePriceFilter('ag-estimated-local-price'),
  price: generatePriceFilter('ag-price'),
  normalized_price: generatePriceFilter('ag-normalized-price'),
  start_date: generateDateFilter(),
  end_date: generateDateFilter(),
  usage: generatePriceFilter('ag-usage'),
  publications: generatePriceFilter('ag-publications'),
  cancellation_deadline: generateDateFilter(),
  cost_per_use_original: generatePriceFilter('ag-cost-per-use-original'),
  cost_per_use_local: generatePriceFilter('ag-cost-per-use-local')
}
